import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import styles from './detailedDocument.scss'
import stylesMifid from './DSWizardHelper.scss'
import Modal from 'react-modal'
import cs from 'classnames'
import { Table, Thead, Th, Tr, Td } from 'components/reactable'
import moment from 'moment'
import i18n from 'lib/i18n'
import nesProp from 'nested-property'
import {
    statusExplainerPopup, customModalStyles, getStatusTranslationKey, getStatusDescriptionTranslationKey,
    isAFailStatus, shouldEditThePackage
} from './documentsHelpers'
import {
    setAppModule, setOpenedSubmenu, setClientSubModule, getClientId, setDSDocumentsOpened,
    setDSDocumentsSubModule, getDsDocsAndPackages, resendClientRemainder, executeFullDSDocumentWizardOnServer,
    getDSStakeholders
} from 'state/actions'
import * as c from 'state/constants'
import ClientContactInfoChangerModalForPackage from './clientContactInfoChangerModalForPackage'
import MifidButton from './mifidButton'
import LinkDocumentModal from './LinkDocumentModal'
import LinkAndUploadButton from './linkAndUploadButton'

const _ = i18n('dsdocuments')

@connect(
    (state) => ({
        // the lits for drop-downs for digi sign in the future use are:
        // DigitalSignatureHardLists: state.app.security.DigitalSignatureHardLists
        paginatedPackages: state.DSDocuments.items,
        packages: state.DSDocuments.packages,
        templates: state.DSDocuments.templates,

        // must fetch the setting
        DigitalSignatureSettings: state.DSDocuments.DigitalSignatureSettings,
        opened: state.DSDocuments.opened,
        clientAccess: state.app.security.actions,
        lang: state.app.lang
    })
)
export default class DetailedDocument extends Component {
    static propTypes = {
        DigitalSignatureSettings: PropTypes.object,
        clientAccess: PropTypes.array,
        onItemActionClick: PropTypes.func,
        determineActionButtonText: PropTypes.func
    }

    constructor(props) {
        super(props)
        this.state = {
            statusExplainerIsOpen: false,
            editClientEmail: false,
            canCreateMifid: false,
            dsdocument: {},
            curentPackage: false,
            isOpenLinkDocumentModal: false,
            stakeholders: null,
            stakeholderToEdit: null
        }
    }

    componentWillMount() {
        const { clientAccess, opened } = this.props

        this.prepareDSDocumentToDisplay(opened)

        // find and set security flag
        clientAccess.map((item, key) => {
            if (item.actionName == 'createmifid') {
                this.setState({ canCreateMifid: item.actionAllowed === "true" ? true : false })
            }
        })
    }

    componentWillReceiveProps(nextProps) {
        const { opened, packages, dsdocuments } = this.props
        const { dsdocument } = this.state

        // handle change document id to display
        if (nextProps.opened !== opened) {
            this.prepareDSDocumentToDisplay(nextProps.opened)
        }

        // check if document content modified
        let newDocs = nesProp.get(nextProps, "dsdocuments")
        if (newDocs) {

            // find the document Object by Id
            let newDoc = nesProp.get(newDocs.filter((item => {
                return (String(item._id) === String(nextProps.opened))
            })), "0")

            // if there is a change of document opened, then refresh  in  state
            if (JSON.stringify(newDocs) !== JSON.stringify(dsdocument)) {

                // change package only if there is an opened document what have package.
                if (nesProp.get(newDoc, "package")) {
                    this.setState({ curentPackage: nesProp.get(newDoc, "package") },
                        () => {
                            // debug place
                        })
                }

                this.setState({ dsdocument: newDoc },
                    () => {
                        // debug place
                    })

            }
        }

        /* let oldPack = packages.filter((item=>{return (item._id === dsdocument.package._id)}))
        let newPack = nextProps.packages.filter((item=>{return (item._id === dsdocument.package._id)})) */

    }

    //remove this and instead get the package object from server via new method
    /**
     * This function will change the document what is used to render.
     */
    prepareDSDocumentToDisplay(dsdocumentId, forceFetch = false) {
        const { dispatch, dsdocuments } = this.props
        let force = true

        new Promise((resolve) => {
            if ((!dsdocuments || dsdocuments.length === 0) || forceFetch) {
                dispatch(getDsDocsAndPackages(force))
                    .then(() => {
                        this.setState({ dsdocument: nesProp.get(dsdocuments.filter((item => { return (item._id === dsdocumentId) })), "0") },
                            () => resolve()
                        )
                    })
            } else {
                this.setState({ dsdocument: nesProp.get(dsdocuments.filter((item => { return (item._id === dsdocumentId) })), "0") },
                    () => resolve()
                )
            }
        })
            //in this step we will get the stakeholders data and put it to state
            .then(() => {
                const currentPackage = nesProp.get(this, "state.dsdocument.package")
                if (currentPackage && currentPackage.stakeholders && currentPackage.stakeholders.length > 0) {
                    return dispatch(getDSStakeholders(currentPackage.stakeholders))
                }
                return []
            })
            .then((stakeholders) => {
                this.setState({ curentPackage: nesProp.get(this, "state.dsdocument.package"), stakeholders })
            })
    }

    /**
     * This function handle the status modal opening
     * @param {string} status
     */
    onItemStatusClick(status) {
        this.setState({ statusExplainerIsOpen: status })
    }

    /**
     * This function helps to use an icon on a safe way
     */
    getIcon = iconName => {
        try {
            return require(`resources/images/${iconName}`)
        } catch (err) {
            return require(`resources/images/icn-no-result.svg`)
        }
    }

    /**
     * This is the call-back function of the email changer popup.
     * @param {string} newEmail - this is the mail address provided by the address changer module
     */
    onAfterUpdateClientEmail = () => {
        const { dispatch } = this.props
        const stakeholders = nesProp.get(this, "state.dsdocument.package.stakeholders")

        //update stakeholders if the case
        if (stakeholders) {
            return dispatch(getDSStakeholders(stakeholders, true))
                .then(response => {
                    this.setState({ editClientEmail: false, editClientPhoneNumber: false, stakeholderToEdit: null, stakeholders: response })
                })
        }
        // release the email changer modal
        this.setState({ editClientEmail: false, stakeholderToEdit: null, editClientPhoneNumber: false })
    }

    /**
     * This function render the status history data-table
     */
    renderStatusHistory = (statusHistory) => {
        return (<div className={styles.statusHistoryContainer}>
            <Table
                ref={el => { this.tableStatusHist = el }}
                id="table"
                className={styles.statusHistoryTable}
                itemsPerPage={50}
                pageButtonLimit={5}
            >
                <Thead>
                    <Th column="setOn">
                        <strong>{_("setOn")}</strong>
                    </Th>
                    <Th column="status">
                        <strong>{_("status")}</strong>
                    </Th>
                </Thead>

                {statusHistory.map((item, key) =>
                    <Tr i={key} key={key}>
                        <Td column="setOn">
                            {(item.setOn && moment(item.setOn).format('DD/MM/YYYY HH:mm:ss')) || "-"}
                        </Td>
                        <Td column="status">
                            <a
                                className={cs(styles.status, styles.goToLink)}
                                onClick={(ev) => {
                                    ev.stopPropagation()
                                    if (item.status) {
                                        this.onItemStatusClick(item.status)
                                    }
                                }}>
                                {item.status ? _(getStatusTranslationKey(item.status)) : '-'}
                            </a>
                        </Td>
                    </Tr>
                )}
            </Table>
            <br />
        </div>)
    }

    /**
     * This function will navigate to the target module by entity id (contracts, claims)
     * @param {object} dsdocument - dsdocument record
     */
    navigateTo(dsdocument) {
        // navigateToModuleName, dynamicId, clientId, options)
        const { dispatch } = this.props
        const clientId = nesProp.get(dsdocument, "package.clientId")
        const contractId = nesProp.get(dsdocument, "contractId")
        const claimId = nesProp.get(dsdocument, "claimId")
        const tarificationId = nesProp.get(dsdocument, "tarificationId")

        let dynamicId = clientId
        let navigateToModuleName = ''

        // navigate by uploaded on module value, not after contract or claim existence (BEWB-231)
        if (dsdocument.uploadedOnModule === c.DS_MODULE_CLIENT_CLAIMS) {
            dynamicId = claimId
            navigateToModuleName = 'claims'
        }

        if (dsdocument.uploadedOnModule === c.DS_MODULE_CLIENT_CONTRACT || c.DS_MODULE_CLIENT_CONTRACT_PREM) {
            dynamicId = contractId
            navigateToModuleName = 'contracts'
        }

        if (dsdocument.uploadedOnModule === c.DS_MODULE_CLIENT_TARIFICATION) {
            dynamicId = tarificationId
            navigateToModuleName = 'tarification'
        }

        // this next line of code (commented) can get clientId from oracle by contract or claim
        // getClientId(contractId, claimId).then((clientId)=>{  })

        dispatch(setAppModule(c.CLIENTS, clientId))
        dispatch(setOpenedSubmenu(dynamicId, {}))// submenuOpened: claimId, subModuleZoom: {}
        dispatch(setClientSubModule(navigateToModuleName))// subModule: 'claims' subModuleZoom: ''
    }

    /**
     * This function extract the signing date from status history.
     * @param {*} dsdocument
     */
    getSigningDate(dsdocument) {
        let statusHistory = nesProp.get(dsdocument, "package.statusHistory")

        if (!statusHistory || statusHistory.length === 0) {
            return false
        }

        let signDate = false
        statusHistory.forEach(oneStatus => {
            if (oneStatus.status === c.DS_PACKAGE_STATUS_FINISHED) {
                signDate = oneStatus.setOn
            }
        })

        return signDate && moment(signDate).format('DD/MM/YYYY HH:mm:ss')
    }

    /**
     * This function could fetch if the package is in a fail state
     * @param {*} statusHistory
     * @returns {object} - {notice: {string}, isAFail: {Bool}}
     */
    getLatestError(status, statusHistory) {
        let result = {
            isAFail: false,
            notice: ''
        }

        if (!statusHistory || statusHistory.length === 0) {
            return result
        }

        // check if the package status is a failed status
        result.isAFail = isAFailStatus(status)

        let lastStatus = nesProp.get(statusHistory, statusHistory.length - 1)
        result.notice = lastStatus.notice

        return result
    }

    /**
     * This function will
     * @param {*} dsDocInstance
     * @param {*} includeHimSelf -Boolean
     */
    findDSDocumentsFromSamePackage(dsDocInstance, includeHimSelf = false) {
        const { dsdocuments } = this.props
        let result = []

        if (!dsdocuments || dsdocuments.length === 0) {
            return result
        }

        result = dsdocuments.filter((item) => {
            let _id = nesProp.get(item, "package._id")
            let _id2 = nesProp.get(dsDocInstance, "package._id")

            return (_id === _id2 && ((!includeHimSelf && dsDocInstance._id !== item._id) || includeHimSelf))
        })

        return result
    }

    /**
     * This function will
     * @param {*} dsDocInstance
     */
    findDSDocumentsFromPackage(packageId) {
        const { dsdocuments } = this.props
        let result = []

        if (!dsdocuments || dsdocuments.length === 0) {
            return result
        }

        result = dsdocuments.filter((item) => {
            let _id = nesProp.get(item, "package._id")
            let _id2 = packageId
            return (_id === _id2)
        })

        return result
    }

    /**
     * This function will navigate to an another document.
     * @param {string} DsDocId
     */
    onClickDSDocInSamePackage(DsDocId) {
        const { dispatch } = this.props

        dispatch(setAppModule(c.DSDOCUMENTS))
        dispatch(setDSDocumentsOpened(''))
        dispatch(setDSDocumentsOpened(DsDocId))
        dispatch(setDSDocumentsSubModule('detailedDSDocument'))
    }

    /**
     * This function will render the table of document from the same package
     * @param {array} docuemntsList - list of documents from same package
     */
    renderDSDocumentsInSamePackage(docuemntsList) {
        return (<div className={styles.statusHistoryContainer}>
            <Table
                ref={el => { this.tableSamePackage = el }}
                id="table"
                className={styles.statusHistoryTable}
                itemsPerPage={50}
                pageButtonLimit={5}
            >
                <Thead>
                    <Th column="createdAt">
                        <strong>{_("createdAt")}</strong>
                    </Th>
                    <Th column="fileName">
                        <strong>{_("fileName")}</strong>
                    </Th>
                </Thead>

                {docuemntsList.map((item, key) =>
                    <Tr i={key} key={key}>
                        <Td column="createdAt">
                            {(item.createdAt && moment(item.createdAt).format('DD/MM/YYYY HH:mm:ss')) || "-"}
                        </Td>
                        <Td column="fileName">
                            <a
                                className={cs(styles.status, styles.goToLink)}
                                onClick={(ev) => {
                                    ev.stopPropagation()
                                    this.onClickDSDocInSamePackage(item._id)
                                }}>
                                {item.fileName}
                            </a>
                        </Td>
                    </Tr>
                )}
            </Table>
        </div>)
    }

    /**
     * After Close wizard refresh the documents list and open the first one if this one is deleted.
     * @param {*} packageId
     */
    onCloseDSWizard(packageId) {
        const { opened, dsdocument, dispatch } = this.props

        // if this document is deleted then navigate to other one
        if (!dsdocument) {
            let brotherDocuments = this.findDSDocumentsFromPackage(packageId)
            dispatch(setAppModule(c.DSDOCUMENTS, ''))
        } else {
            this.prepareDSDocumentToDisplay(opened, true)
        }
    }

    /**
     * This function provide false if can be sent a remainder.
     * this is adapted for version 8
     * @param {*} dsPackage
     */
    shouldSendRemainder(dsPackage) {
        let should = false
        const templates = dsPackage && dsPackage.dsDocuments && dsPackage.dsDocuments.map(oneDoc => {
            return oneDoc.documentTemplate
        })
        // can be enabled the remainder when there are minimum one document what should be signed
        if (dsPackage && dsPackage.dsDocuments && dsPackage.dsDocuments.length > 0 && templates && templates.length > 0) {
            dsPackage.dsDocuments.forEach((oneDoc) => {
                templates.forEach((oneTemplate) => {
                    if ((String(oneDoc.documentTemplateId) === String(oneTemplate._id)) &&
                        oneTemplate.mustBeSigned) {
                        should = true
                    }
                })
            })
        }

        // no status history, normally never happen this
        if (!dsPackage || !dsPackage.statusHistory) {
            return should
        }

        // check if not closed the package
        dsPackage.statusHistory.forEach((oneStatus) => {
            // the best case, when signed, no more remainder necessary
            if (oneStatus.status === c.DS_PACKAGE_STATUS_FINISHED) {
                should = false
            }

            // any cases when the package life is over, no more remainder necessary
            if (oneStatus.status === c.DS_PACKAGE_STATUS_REJECTED ||
                oneStatus.status === c.DS_PACKAGE_STATUS_REVOKED ||
                oneStatus.status === c.DS_PACKAGE_STATUS_EXPIRED ||
                oneStatus.status === c.DS_PACKAGE_STATUS_FAILED ||
                oneStatus.status === c.DS_PACKAGE_STATUS_DELETED
            ) {
                should = false
            }
        })

        return should
    }

    /**
     * This function provide false if the package is not signed.
     * @param {*} status
     * @param {*} statusHistory
     */
    isSignedPackage(status, statusHistory) {
        let isSigned = (status === c.DS_PACKAGE_STATUS_FINISHED)

        if (!statusHistory) {
            return isSigned
        }

        statusHistory.forEach((oneStatus) => {
            if (oneStatus.status === c.DS_PACKAGE_STATUS_FINISHED) {
                isSigned = true
            }
        })

        return isSigned
    }

    /**
     * This function provide true if the package is expired and not signed.
     * @param {*} status
     * @param {*} statusHistory
     */
    isExpiredPackage(status, statusHistory) {
        let isExpired = (status === 'packageStatusExpired')

        if (!statusHistory) {
            return isExpired
        }

        statusHistory.forEach((oneStatus) => {
            if (oneStatus.status === c.DS_PACKAGE_STATUS_FINISHED) {
                isExpired = false
            }
        })

        return isExpired
    }

    /***
     * Event handler for on resent the email.
     */
    onResendClientRemainder = async (packageId, stakeholderId = null) => {
        const { dispatch } = this.props
        const stakeholders = nesProp.get(this, "state.dsdocument.package.stakeholders")
        const resendReminderRes = await dispatch(resendClientRemainder(packageId, stakeholderId))
        if (resendReminderRes) {
            const updatedStakeholders = await dispatch(getDSStakeholders(stakeholders))
            this.setState({ stakeholders: updatedStakeholders })
        }
    }

    /**
     * Open the model for linking or uploading document
     * @param {*} dsDocument
     */
    openLinkAndUploadWizard(dsDocument) {
        this.setState({ isOpenLinkDocumentModal: dsDocument })
    }

    /**
     * Refresh the document tho show the latest updated details
     * @param {function} onSubmit
     * @returns
     */
    simpleRefresh() {
        const { dispatch } = this.props

        return dispatch(getDsDocsAndPackages(true))
            .then((result) => {
                return this.forceUpdate()
            })
            .catch((err) => {
                return this.forceUpdate()
            })
    }

    renderStakeholdersArea(stakeholders, dsdocument, isEditableThePackage, shouldSendRemainder) {
        const { curentPackage } = this.state
        const canSendNextReminder = +dsdocument.package.remainderRepeats > 0 ? true : false
        const signatureType = dsdocument.documentTemplate.digitalSignatureType

        return (
            <div>
                <h2 className={`${styles.mainTitle}`}>
                    {_('signersArea')}
                </h2>
                <div className={styles.dsdocumentHeaderContainer}>
                    <div className={styles.columnWrapper}>
                        <div className={styles.signersLabelsColumn}>
                            <div className={cs(styles.row)}>
                                <p className={cs(styles.signersLabel, styles.columnTitle)}> </p>
                            </div>
                            <div className={cs(styles.row)}>
                                <p className={cs(styles.signersLabel)}>{_('signerName')}</p>
                            </div>
                            <div className={cs(styles.row)}>
                                <p className={cs(styles.signersLabel)}>{_('signerEmail')}</p>
                            </div>
                            {signatureType === "SmsOtp" &&
                                <div className={cs(styles.row)}>
                                    <p className={cs(styles.signersLabel)}>{_('signerPhoneNumber')}</p>
                                </div>
                            }
                            <div className={cs(styles.row)}>
                                <p className={cs(styles.signersLabel)}>{_('signerLanguage')}</p>
                            </div>
                            <div className={cs(styles.row)}>
                                <p className={cs(styles.signersLabel)}>{_('lastRemainderSentOn')}</p>
                            </div>
                            <div className={cs(styles.row)}>
                                <p className={cs(styles.signersLabel)}>{_('nextRemainderSendOn')}</p>
                            </div>
                            <div className={cs(styles.row)}>
                                <p className={cs(styles.signersLabel)}>{_('remainderCount')}</p>
                            </div>
                            <div className={cs(styles.row)}>
                                <p className={cs(styles.signersLabel)}>{_('manuallRemainderCount')}</p>
                            </div>
                            <div className={cs(styles.row)}>
                                <p className={cs(styles.signersLabel)}>{_('signingStatusLabel')}</p>
                            </div>
                        </div>

                        <div className={styles.firstSignerColumn}>
                            <div className={cs(styles.row)}>
                                <p className={cs(styles.signer, styles.columnTitle)}>{_('firstSignerColumnTitle')}</p>
                            </div>
                            <div className={cs(styles.row)}>
                                <p className={cs(styles.signer)}>{stakeholders[0].lastName + ' ' + stakeholders[0].firstName}</p>
                            </div>
                            <div className={cs(styles.row)}>
                                <div className={styles.signer}>
                                    <div className={styles.email}>
                                        <a href={`mailto:${stakeholders[0].email}`}>{stakeholders[0].email}</a>
                                        {!stakeholders[0].finished &&
                                            <img className={styles.icon} src={this.getIcon('create-24px.svg')}
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    this.setState({ editClientEmail: true, stakeholderToEdit: stakeholders[0] })
                                                }} />}
                                    </div>
                                </div>
                            </div>
                            {signatureType === "SmsOtp" &&
                                <div className={cs(styles.row)}>
                                    <div className={styles.signer}>
                                        <div className={styles.email}>
                                            <a href={`mailto:${stakeholders[0].phoneNumber}`}>{stakeholders[0].phoneNumber}</a>
                                            {!stakeholders[0].finished &&
                                                <img className={styles.icon} src={this.getIcon('create-24px.svg')}
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        this.setState({ editClientPhoneNumber: true, stakeholderToEdit: stakeholders[0] })
                                                    }} />}
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className={cs(styles.row)}>
                                <p className={cs(styles.signer)}>{stakeholders[0].language}</p>
                            </div>
                            {isEditableThePackage ?
                                <div className={cs(styles.row)}>
                                    <p className={styles.signer}>{_('reminderSentOnNotReady')}</p>
                                </div>
                                :
                                <div className={cs(styles.row)}>
                                    <p className={styles.signer}>{moment(nesProp.get(stakeholders[0], "reminderSentOn")).format("DD/MM/YYYY HH:mm:ss")}</p>
                                </div>
                            }
                            {!isEditableThePackage ?
                                canSendNextReminder ?
                                    <div className={cs(styles.row)}>
                                        <p className={styles.signer}>{moment(nesProp.get(stakeholders[0], "nextRemainderOn")).format("DD/MM/YYYY HH:mm:ss")}</p>
                                    </div>
                                    :
                                    <div className={cs(styles.row)}>
                                        <p className={styles.signer}>-</p>
                                    </div>
                                :
                                <div className={cs(styles.row)}>
                                    <p className={styles.signer}>{_('nextReminderNotReady')}</p>
                                </div>
                            }
                            <div className={cs(styles.row)}>
                                <p className={styles.signer}>{((nesProp.get(stakeholders[0], "remainderRepeats") + "" === "-1") ?
                                    _("infinite") : nesProp.get(stakeholders[0], "remainderSentCount"))
                                    + " / " + nesProp.get(curentPackage, "remainderRepeats")}</p>
                            </div>
                            <div className={cs(styles.row)}>
                                <p className={styles.signer}>{((nesProp.get(stakeholders[0], "remainderRepeats") + "" === "-1") ?
                                    _("infinite") : (nesProp.get(stakeholders[0], "remainderSentCountManually") || 0))
                                    + " / " + _("infinite")}</p>
                            </div>
                            <div className={cs(styles.row)}>
                                {stakeholders[0].finished &&
                                    <p className={cs(styles.signer)}>{_('signerHasSignedStatus')}</p> ||
                                    <p className={cs(styles.signer)}>{_('signerHasNotSignedStatus')}</p>
                                }
                            </div>
                            {!stakeholders[0].finished && !isEditableThePackage && shouldSendRemainder &&
                                <div className={cs(styles.row)}>
                                    <div className={cs(stylesMifid.mifidButtonContainer)}>
                                        <div
                                            key={"resentButton"}
                                            className={cs(stylesMifid.grayButtonFlex, stylesMifid.mifidButton)}
                                            onClick={(e) => (this.onResendClientRemainder(nesProp.get(dsdocument, "package._id"), stakeholders[0]._id))}
                                        >
                                            <img className={cs(styles.icon, styles.iconPaddingRight)} src={this.getIcon('icn-inbox-white.svg')} />
                                            {_('resendRemainderEmail')}
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>

                        {stakeholders.length > 1 &&
                            <div className={styles.firstSignerColumn}>
                                <div className={cs(styles.row)}>
                                    <p className={cs(styles.signer, styles.columnTitle)}>{_('secondSignerColumnTitle')}</p>
                                </div>
                                <div className={cs(styles.row)}>
                                    <p className={cs(styles.signer)}>{stakeholders[1].lastName + ' ' + stakeholders[1].firstName}</p>
                                </div>
                                <div className={cs(styles.row)}>
                                    <div className={styles.signer}>
                                        <div className={styles.email}>
                                            <a href={`mailto:${stakeholders[1].email}`}>{stakeholders[1].email}</a>
                                            {!stakeholders[1].finished &&
                                                <img className={styles.icon} src={this.getIcon('create-24px.svg')}
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        this.setState({ editClientEmail: true, stakeholderToEdit: stakeholders[1] })
                                                    }} />}
                                        </div>
                                    </div>
                                </div>
                                {signatureType === "SmsOtp" &&
                                    <div className={cs(styles.row)}>
                                        <div className={styles.signer}>
                                            <div className={styles.email}>
                                                <a href={`mailto:${stakeholders[1].phoneNumber}`}>{stakeholders[1].phoneNumber}</a>
                                                {!stakeholders[0].finished &&
                                                    <img className={styles.icon} src={this.getIcon('create-24px.svg')}
                                                        onClick={(e) => {
                                                            e.preventDefault()
                                                            this.setState({ editClientPhoneNumber: true, stakeholderToEdit: stakeholders[1] })
                                                        }} />}
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className={cs(styles.row)}>
                                    <p className={cs(styles.signer)}>{stakeholders[1].language}</p>
                                </div>
                                {isEditableThePackage ?
                                    <div className={cs(styles.row)}>
                                        <p className={styles.signer}>{_('reminderSentOnNotReady')}</p>
                                    </div>
                                    :
                                    <div className={cs(styles.row)}>
                                        <p className={styles.signer}>{moment(nesProp.get(stakeholders[1], "reminderSentOn")).format("DD/MM/YYYY HH:mm:ss")}</p>
                                    </div>
                                }
                                {!isEditableThePackage ?
                                    canSendNextReminder ?
                                        <div className={cs(styles.row)}>
                                            <p className={styles.signer}>{moment(nesProp.get(stakeholders[1], "nextRemainderOn")).format("DD/MM/YYYY HH:mm:ss")}</p>
                                        </div>
                                        :
                                        <div className={cs(styles.row)}>
                                            <p className={styles.signer}>-</p>
                                        </div>
                                    :
                                    <div className={cs(styles.row)}>
                                        <p className={styles.signer}>{_('nextReminderNotReady')}</p>
                                    </div>
                                }
                                <div className={cs(styles.row)}>
                                    <p className={styles.signer}>{((nesProp.get(stakeholders[1], "remainderRepeats") + "" === "-1") ?
                                        _("infinite") : nesProp.get(stakeholders[1], "remainderSentCount"))
                                        + " / " + nesProp.get(curentPackage, "remainderRepeats")}</p>
                                </div>
                                <div className={cs(styles.row)}>
                                    <p className={styles.signer}>{((nesProp.get(stakeholders[1], "remainderRepeats") + "" === "-1") ?
                                        _("infinite") : (nesProp.get(stakeholders[1], "remainderSentCountManually") || 0))
                                        + " / " + _("infinite")}</p>
                                </div>
                                <div className={cs(styles.row)}>
                                    {stakeholders[1].finished &&
                                        <p className={cs(styles.signer)}>{_('signerHasSignedStatus')}</p> ||
                                        <p className={cs(styles.signer)}>{_('signerHasNotSignedStatus')}</p>
                                    }
                                </div>
                                {!stakeholders[1].finished && !isEditableThePackage && shouldSendRemainder &&
                                    <div className={cs(styles.row)}>
                                        <div className={cs(stylesMifid.mifidButtonContainer)}>
                                            <div
                                                key={"resentButton"}
                                                className={cs(stylesMifid.grayButtonFlex, stylesMifid.mifidButton)}
                                                onClick={(e) => (this.onResendClientRemainder(nesProp.get(dsdocument, "package._id"), stakeholders[1]._id))}
                                            >
                                                <img className={cs(styles.icon, styles.iconPaddingRight)} src={this.getIcon('icn-inbox-white.svg')} />
                                                {_('resendRemainderEmail')}
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }


    renderSignerArea(clientEmailAddress, dsdocument, isEditableThePackage, shouldSendRemainder) {
        const { curentPackage } = this.state
        let isSignedThePackage = this.isSignedPackage(
            nesProp.get(curentPackage, "status"),
            nesProp.get(curentPackage, "statusHistory")
        )
        const canSendNextReminder = +dsdocument.package.remainderRepeats > 0 ? true : false

        return (
            <div>
                <h2 className={`${styles.mainTitle}`}>
                    {_('signersArea')}
                </h2>
                <div className={styles.dsdocumentHeaderContainer}>
                    <div className={styles.columnWrapper}>
                        <div className={styles.signersLabelsColumn}>
                            <div className={cs(styles.row)}>
                                <p className={cs(styles.signersLabel, styles.columnTitle)}> </p>
                            </div>
                            <div className={cs(styles.row)}>
                                <p className={cs(styles.signersLabel)}>{_('signerName')}</p>
                            </div>
                            <div className={cs(styles.row)}>
                                <p className={cs(styles.signersLabel)}>{_('signerEmail')}</p>
                            </div>
                            <div className={cs(styles.row)}>
                                <p className={cs(styles.signersLabel)}>{_('signerLanguage')}</p>
                            </div>
                            <div className={cs(styles.row)}>
                                <p className={cs(styles.signersLabel)}>{_('lastRemainderSentOn')}</p>
                            </div>
                            <div className={cs(styles.row)}>
                                <p className={cs(styles.signersLabel)}>{_('nextRemainderSendOn')}</p>
                            </div>
                            <div className={cs(styles.row)}>
                                <p className={cs(styles.signersLabel)}>{_('lastRemainderSentOn')}</p>
                            </div>
                        </div>

                        <div className={styles.firstSignerColumn}>
                            <div className={cs(styles.row)}>
                                <p className={cs(styles.signer, styles.columnTitle)}>{_('firstSignerColumnTitle')}</p>
                            </div>
                            <div className={cs(styles.row)}>
                                <p className={cs(styles.signer)}>{nesProp.get(dsdocument, "package.clientName")}</p>
                            </div>
                            <div className={cs(styles.row)}>
                                <div className={styles.signer}>
                                    <div className={styles.email}>
                                        <a href={`mailto:${clientEmailAddress}`}>{clientEmailAddress}</a>

                                        {!isSignedThePackage &&
                                            <img className={styles.icon} src={this.getIcon('create-24px.svg')}
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    this.setState({ editClientEmail: true })
                                                }} />}

                                    </div>
                                </div>
                            </div>
                            <div className={cs(styles.row)}>
                                <p className={cs(styles.signer)}>{dsdocument.language}</p>
                            </div>
                            <div className={cs(styles.row)}>
                                <p className={styles.signer}>{moment(nesProp.get(curentPackage, "reminderSentOn")).format("DD/MM/YYYY HH:mm:ss")}</p>

                            </div>
                            {canSendNextReminder ?
                                <div className={cs(styles.row)}>
                                    <p className={styles.signer}>{moment(nesProp.get(curentPackage, "nextRemainderOn")).format("DD/MM/YYYY HH:mm:ss")}</p>
                                </div>
                                :
                                <div className={cs(styles.row)}>
                                    <p className={styles.signer}>-</p>
                                </div>
                            }
                            <div className={cs(styles.row)}>
                                <p className={styles.signer}>{((nesProp.get(curentPackage, "remainderRepeats") + "" === "-1") ?
                                    _("infinite") : nesProp.get(curentPackage, "remainderSentCount"))
                                    + " / " + nesProp.get(curentPackage, "remainderRepeats")}</p>
                            </div>
                            {!isEditableThePackage && shouldSendRemainder &&
                                <div className={cs(styles.row)}>
                                    <div className={cs(stylesMifid.mifidButtonContainer)}>
                                        <div
                                            key={"resentButton"}
                                            className={cs(stylesMifid.grayButtonFlex, stylesMifid.mifidButton)}
                                            onClick={(e) => (this.onResendClientRemainder(nesProp.get(dsdocument, "package._id"), null))}
                                        >
                                            <img className={cs(styles.icon, styles.iconPaddingRight)} src={this.getIcon('icn-inbox-white.svg')} />
                                            {_('resendRemainderEmail')}
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    /**
     * Render hook of react
     */
    render() {
        const { lang, templates } = this.props
        const { statusExplainerIsOpen, editClientEmail, canCreateMifid, dsdocument, curentPackage,
            isOpenLinkDocumentModal, stakeholders, stakeholderToEdit, editClientPhoneNumber } = this.state
        // few flags for render conditions
        let isEditableThePackage = shouldEditThePackage(
            nesProp.get(curentPackage, "statusHistory"),
            nesProp.get(curentPackage, "isEditable")
        )

        // if there are no package let the mifid button to render by setting this
        if (!curentPackage) {
            isEditableThePackage = true
        }

        // filter the document in two way, including himself and without
        const docsInPackage = this.findDSDocumentsFromSamePackage(dsdocument, true)
        const dsdocumentsInSamePackageList = this.findDSDocumentsFromSamePackage(dsdocument, false)

        // calculate and collect flags for logical operations
        let shouldSendRemainder = this.shouldSendRemainder(
            nesProp.get(curentPackage, "statusHistory"),
            docsInPackage,
            templates
        )

        let isSignedThePackage = this.isSignedPackage(
            nesProp.get(curentPackage, "status"),
            nesProp.get(curentPackage, "statusHistory")
        )

        let mustBeSigned = dsdocument.documentTemplate && dsdocument.documentTemplate.mustBeSigned
        let isUploaded = dsdocument.uploadedToOracle

        // collect ID-s and numbers for table
        const contractId = nesProp.get(curentPackage, "contractId")
        const claimId = nesProp.get(curentPackage, "claimId")
        const claimNumber = nesProp.get(curentPackage, "claimNumber")
        const contractNumber = nesProp.get(curentPackage, "contractNumber")

        let isExpiredThePackage = this.isExpiredPackage(
            nesProp.get(curentPackage, "status"),
            nesProp.get(curentPackage, "statusHistory")
        )

        // fetch error state is has
        const statusErrorState = this.getLatestError(
            nesProp.get(curentPackage, "status"),
            nesProp.get(curentPackage, "statusHistory")
        )

        const statusHistory = nesProp.get(curentPackage, "statusHistory")
        const clientEmailAddress = nesProp.get(curentPackage, "clientEmailAddress")

        // don't show the last status, must shown the signed status in case when the document is signed: BEWB-445
        let statusToShow = nesProp.get(curentPackage, "status") || ""
        if (mustBeSigned) {
            if (isSignedThePackage) {
                statusToShow = c.DS_PACKAGE_STATUS_FINISHED
            }
        } else {
            if (isUploaded) {
                statusToShow = c.DS_DOCUMENTS_TRANSFERRED_TO_ORACLE
            }
        }

        return (
            <div className={styles.dsdocumentContainer}>
                <h2 className={`${styles.mainTitle}`}>
                    {_('dsdocumentName') + (dsdocument && ' - "' + nesProp.get(dsdocument, "fileName") + '"' || '')}
                </h2>
                {dsdocument &&
                    <div className={styles.dsdocumentHeaderContainer}>
                        <div className={styles.columnWrapper}>
                            <div className={cs(styles.columnLeft)}>
                                <div className={cs(styles.row)}>
                                    <p className={styles.column}>{_('documentTemplate')}: </p>
                                    <p className={styles.column}>{nesProp.get(dsdocument, "documentTemplate.title." + lang)}</p>
                                </div>
                                <div className={cs(styles.row)}>
                                    <p className={styles.column}>{_('clientName')}: </p>
                                    <p className={styles.column}>{nesProp.get(dsdocument, "package.clientName")}</p>
                                </div>
                                <div className={cs(styles.row)}>
                                    <p className={styles.column}>{_('brokerNumber')}: </p>
                                    <p className={styles.column}>{nesProp.get(dsdocument, "package.brokerNumber")}</p>
                                </div>
                                {contractNumber &&
                                    <div className={cs(styles.row)}>
                                        <p className={styles.column}>{_('contractNumber')}: </p>
                                        <p className={styles.column}>{contractNumber}</p>
                                    </div>}
                                <div className={cs(styles.row)}>
                                    <p className={styles.column}>{_('documentLocation')}: </p>
                                    <a className={cs(styles.column, styles.goToLink)}
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            this.navigateTo(dsdocument, false)
                                        }}
                                    >
                                        {dsdocument.uploadedOnModule === c.DS_MODULE_CLIENT_CLAIMS && _('goToClaims')}
                                        {dsdocument.uploadedOnModule === c.DS_MODULE_CLIENT_CONTRACT && _('goToContracts')}
                                        {dsdocument.uploadedOnModule === c.DS_MODULE_CLIENT_CONTRACT_PREM && _('goToContracts')}
                                        {dsdocument.uploadedOnModule === c.DS_MODULE_CLIENT_PROFILE && _('goToProfile')}
                                        {dsdocument.uploadedOnModule === c.DS_MODULE_CLIENT_TARIFICATION && _('goToTarification')}
                                    </a>
                                </div>
                                <div className={cs(styles.row)}>
                                    <p className={styles.column}>{_('packageName')}: </p>
                                    <p className={styles.column}>{nesProp.get(dsdocument, "package.connectivePackageName")}</p>
                                </div>
                                <div className={cs(styles.row)}>
                                    <p className={styles.column}>{_('documentLanguage')}: </p>
                                    <p className={styles.column}>{dsdocument.language}</p>
                                </div>
                            </div>


                            <div className={cs(styles.columnRight)}>
                                <div className={cs(styles.row)}>
                                    <p className={styles.column}>{_('createdAt')}: </p>
                                    <p className={styles.column}>
                                        {(dsdocument && dsdocument.createdAt && moment(dsdocument.createdAt).format('DD/MM/YYYY HH:mm:ss')) || "-"}
                                    </p>
                                </div>
                                <div className={cs(styles.row)}>
                                    <p className={styles.column}>{_('updatedAt')}: </p>
                                    <p className={styles.column}>
                                        {((dsdocument.updatedAt != undefined) && moment(dsdocument.updatedAt).format('DD/MM/YYYY HH:mm:ss')) || "-"}
                                    </p>
                                </div>
                                <div className={cs(styles.row)}>
                                    <p className={styles.column}>{_('signedAt')}: </p>
                                    <p className={styles.column}>
                                        {this.getSigningDate(dsdocument) || "-"}
                                    </p>
                                </div>
                                <div className={cs(styles.row)}>
                                    <p className={styles.column}>{_('packageStatus')}: </p>
                                    <a className={cs(styles.column, styles.goToLink)}
                                        onClick={(ev) => {
                                            ev.stopPropagation()
                                            if (statusToShow) {
                                                this.onItemStatusClick(statusToShow)
                                            }
                                        }}
                                    >
                                        {statusToShow ? _(getStatusTranslationKey(statusToShow)) : ''}
                                    </a>
                                </div>
                                <div className={cs(styles.row)}>
                                    <p className={styles.column}>{_('packageExpiration')}: </p>
                                    <p className={styles.column}>{nesProp.get(dsdocument, "package.expirationOn")}</p>
                                </div>

                                <div className={cs(styles.row)}>
                                    <div className={cs(styles.row, styles.mifidContainer)}>

                                        {canCreateMifid &&
                                            <MifidButton
                                                step={c.DSWIZARD_STEP_1_COMPOSE_PACKAGE}
                                                packageId={nesProp.get(dsdocument, "package._id")}
                                                lang={lang}
                                                callBackOnClose={() => { this.onCloseDSWizard() }}
                                                moduleKeyToSet={nesProp.get(dsdocument, "package.uploadedOnModule")}

                                                clientId={nesProp.get(dsdocument, "package.clientId")}
                                                claimId={nesProp.get(dsdocument, "package.claimId")}
                                                claimNumber={nesProp.get(dsdocument, "package.claimNumber")}
                                                contractId={nesProp.get(dsdocument, "package.contractId")}
                                                contractNumber={nesProp.get(dsdocument, "package.contractNumber")}
                                                tarificationId={nesProp.get(dsdocument, "package.tarificationId")}
                                                tarificationNumber={nesProp.get(dsdocument, "package.tarificationNumber")}
                                                stakeholders={stakeholders}

                                                hideButton={!isEditableThePackage}
                                                isResume={true}
                                            />
                                        }
                                        {<LinkAndUploadButton dsDocument={dsdocument} templates={templates}
                                            openLinkAndUploadWizard={(dsDocument) => {
                                                return this.openLinkAndUploadWizard(dsDocument)
                                            }}
                                        />}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }

                {dsdocument.documentTemplate && dsdocument.documentTemplate.mustBeSigned ?
                    (stakeholders && stakeholders.length > 0 ? this.renderStakeholdersArea(stakeholders, dsdocument, isEditableThePackage, shouldSendRemainder) :
                        (clientEmailAddress ? this.renderSignerArea(clientEmailAddress, dsdocument, isEditableThePackage, shouldSendRemainder) : null))
                    :
                    (dsdocument.documentTemplate && !dsdocument.documentTemplate.mustBeSigned ?
                        (<div>
                            <h2 className={`${styles.mainTitle}`}>
                                {_('signersArea')}
                            </h2>
                            <div className={styles.dsdocumentHeaderContainer}>
                                <div className={styles.signersLabelsColumn}>
                                    <div className={cs(styles.row)}>
                                        <p className={cs(styles.signersLabel)}>{_('documentNotRequireSignig')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>)
                        : null)
                }

                <h2 className={`${styles.mainTitle}`}>
                    {_('packageStatusHistory')}
                </h2>
                <div className={styles.dsdocumentHeaderContainer}>
                    <div className={cs(styles.row)}>
                        <div className={styles.column}>
                            {statusHistory && statusHistory.length > 0 &&
                                this.renderStatusHistory(statusHistory)
                            }
                        </div>
                    </div>
                </div>

                {(dsdocumentsInSamePackageList && dsdocumentsInSamePackageList.length > 0) &&
                    <div>
                        <h2 className={`${styles.mainTitle}`}>
                            {_('dsdocumentsInSamePackages')}
                        </h2>
                        <div className={styles.dsdocumentHeaderContainer}>
                            <div className={cs(styles.row)}>
                                <div className={styles.column}>
                                    {this.renderDSDocumentsInSamePackage(dsdocumentsInSamePackageList)}
                                </div>
                            </div>
                        </div>
                    </div>
                }

                <h2 className={`${styles.mainTitle}`}>
                    {_('technicalInfo')}
                </h2>
                <div className={styles.dsdocumentHeaderContainer}>
                    <div className={styles.columnWrapper}>
                        <div className={cs(styles.columnLeft)}>
                            <div className={cs(styles.row)}>
                                <p className={styles.column}>{_('isContractSpecific')}: </p>
                                <p className={styles.column}>{nesProp.get(dsdocument, "package.contractId") ? _("yes") : _("no")}</p>
                            </div>
                            <div className={cs(styles.row)}>
                                <p className={styles.column}>{_('connectiveDocumentId')}: </p>
                                <p className={styles.column}>{nesProp.get(dsdocument, "connectiveDocumentId")}</p>
                            </div>
                        </div>
                        <div className={cs(styles.columnRight)}>
                            <div className={cs(styles.row)}>
                                <p className={styles.column}>{_('digitalSignatureType')}: </p>
                                <p className={styles.column}>{nesProp.get(dsdocument, "documentTemplate.digitalSignatureType")}</p>
                            </div>
                            <div className={cs(styles.row)}>
                                <p className={styles.column}>{_('datasetName')}: </p>
                                <p className={styles.column}>{nesProp.get(dsdocument, "documentTemplate.dataSetId.datasetName")}</p>
                            </div>
                        </div>
                    </div>
                </div>


                <div className={styles.dsdocumentHeaderContainer}>
                    {claimNumber &&
                        <div className={cs(styles.row)}>
                            <p className={styles.column}>{_('claimNumber')}: </p>
                            <p className={styles.column}>{claimNumber}</p>
                        </div>}

                    {statusErrorState.isAFail &&
                        <div className={cs(styles.row)}>
                            <p className={styles.column}>{_('failedMessage')}: </p>
                            <p className={styles.column}>{statusErrorState.notice || "-"}</p>
                        </div>}

                    {/* <div className={cs(styles.row)}>
                        <p className={styles.column}>{_('uploadedOnModule')}: </p>
                        <p className={styles.column}>{dsdocument.uploadedOnModule}</p>
                    </div> */}

                    {/* <div className={cs(styles.row)}>
                        <p className={styles.column}>{_('accessLink')}: </p>
                        <p className={styles.column}>{nesProp.get(dsdocument,"package.accessLink")}</p>
                    </div> */}
                </div>

                <Modal
                    isOpen={Boolean(statusExplainerIsOpen)}
                    style={customModalStyles}
                >
                    {statusExplainerPopup(
                        _(getStatusTranslationKey(statusExplainerIsOpen)),
                        _(getStatusDescriptionTranslationKey(statusExplainerIsOpen)),
                        () => {
                            this.setState({ statusExplainerIsOpen: false })
                        },
                        _("ok")
                    )}
                </Modal>

                <ClientContactInfoChangerModalForPackage
                    dsdocument={dsdocument}
                    triggerToOpen={editClientEmail || editClientPhoneNumber}
                    editClientEmail={editClientEmail}
                    editClientPhoneNumber={editClientPhoneNumber}
                    stakeholder={stakeholderToEdit}
                    isEditableThePackage={isEditableThePackage}
                    callBackOnClose={() => { this.onAfterUpdateClientEmail() }}
                />

                <LinkDocumentModal
                    modalIsOpen={!!isOpenLinkDocumentModal}
                    onCancel={() => {
                        this.setState({ isOpenLinkDocumentModal: false })
                        this.simpleRefresh()
                    }}
                    onConfirmation={() => {
                        this.simpleRefresh()
                        this.setState({ isOpenLinkDocumentModal: false })
                    }}
                    flag={'LinkDocumentModal'}
                    payload={isOpenLinkDocumentModal ?
                        {
                            dsdocument: isOpenLinkDocumentModal
                        } : {}
                    }
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/DSDocuments/detailedDocument.jsx